export const columnLabels = {
    id: 'ID',
    candidate_id: 'Кандидат',
    vacancy_names: 'Вакансия',
    description: 'Описание',
    deadline: 'Срок',
    assignee_id: 'Исполнитель',
    co_assignee_id: 'Соисполнитель',
    observer_id: 'Наблюдатель',
    creator_id: 'Создатель',
    comment: 'Комментарий',
    created_at: 'Создано',
    status: 'Статус',
    result: 'Результат',
    actions: 'Действия',
};


export const STATUSES = {
    new: {
        title: 'Новая',
        color: '#1890ff' // Синий - новая задача
    },
    in_progress: {
        title: 'В работе',
        color: '#fa8c16' // Оранжевый - активная работа
    },
    closed: {
        title: 'Закрыта',
        color: '#52c41a' // Зеленый - закрытая задача
    },
};
